// action types
export const LOGIN = "login";
export const LOGOUT = "logout";
export const SET_TOKEN = "SET_TOKEN";

export const PURGE_AUTH = "PURGE_AUTH";
export const SET_AUTH = "SET_AUTH";
export const SET_STATUS = "SET_STATUS";
export const CHANGE_AUTH = "CHANGE_AUTH";